export default {
  generalInformation: 'اطلاعات کلی',
  profilePicture: 'تصاویر پروفایل',
  socialConnections: 'ارتباطات',
};
